"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
var _Category = _interopRequireDefault(require("@/common/model/Category"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
// 商品分类选择器组件
var _default = exports.default = {
  name: 'SGoodsCate',
  components: {},
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: _vueTypes.default.integer.def(-1)
  },
  data: function data() {
    return {
      // 正在加载
      isLoading: false,
      // 分类列表
      categoryListTree: [],
      // 选择的分类ID
      selectedId: -1
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler: function handler(val) {
        this.selectedId = val;
      }
    }
  },
  created: function created() {
    // 获取分类列表
    this.getCategoryList();
  },
  methods: {
    // 获取分类列表
    getCategoryList: function getCategoryList() {
      var _this = this;
      this.isLoading = true;
      _Category.default.getListFromScreen().then(function (selectList) {
        return _this.categoryListTree = selectList;
      }).finally(function (result) {
        return _this.isLoading = false;
      });
    },
    // 触发change事件
    onChange: function onChange(value) {
      this.$emit('change', value);
    }
  }
};